import * as React from 'react';
import styled from 'styled-components';
import { OnPrimaryColor, PrimaryColor } from '../../styles/global/css/Utils';
import { TOP_HEADBAND_HEIGHT_NB, TopHeadBandContext } from '../../containers_v2/topHeadBand/TopHeadBandProvider';
import { DefaultText } from '../../styles/global/css/GlobalText';
import { SIDEBAR_CLOSE_WIDTH } from '../sidebar/style';

export type TableCellToolTipStyleProps = {
	backgroundColor?: string
	borderColor?: string
}

export type TableCellToolTipProps = TableCellToolTipStyleProps & {
	bounds: DOMRect,
	content: React.ReactNode
	maxWidth?: string,
	center?: boolean
}

const TableCellToolTipDiv = styled.div<{ bounds: DOMRect, center: boolean | undefined, headBandOpen: boolean, backgroundColor: string, borderColor: string }>`
	${DefaultText}
	position: absolute;
	padding: 0.25em 1em;
	background-color: ${p => p.backgroundColor};
	left: calc(${p => p.bounds.left}px - ${SIDEBAR_CLOSE_WIDTH}px);
	top: ${p => p.bounds.top - (p.headBandOpen ? TOP_HEADBAND_HEIGHT_NB : 0)}px;
	border-radius: 8px;
	z-index: 8;
	color: ${OnPrimaryColor};
	&:after {
		content: " ";
		position: absolute;
		top: 100%;
		left: 50%;
		margin-left: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: ${p => p.borderColor} transparent transparent transparent;
	}
	border: 1px solid ${p => p.borderColor};
	translate: ${p => p.center ? `calc(-50% + ${p.bounds.width / 2}px)` : '0'} calc(-100% - 5px);

`;

const ToolTipContentDiv = styled.div<{ maxWidth: string | undefined }>`
	${({ maxWidth }) => maxWidth ? `max-width: ${maxWidth};` : ''}

`;

export default function TableCellToolTip(props: TableCellToolTipProps): JSX.Element {
	const { bounds, content, borderColor, backgroundColor } = props;
	const headBand = React.useContext(TopHeadBandContext);
	return <>
		<TableCellToolTipDiv
			bounds={bounds}
			center={props.center}
			headBandOpen={headBand.isOpen}
			backgroundColor={backgroundColor ?? PrimaryColor}
			borderColor={borderColor ?? PrimaryColor}
		>
			<ToolTipContentDiv maxWidth={props.maxWidth}>
				{content}
			</ToolTipContentDiv>
		</TableCellToolTipDiv>
	</>;
}
